export default __webpack_public_path__ + "static/media/poodlTwo.f690f3b1.jpg";